/**
 * スクロールに応じてボディクラスを制御する関数
 * @param {Function} func - 実行する関数
 * @param {number} wait - 待機時間（ミリ秒）
 * @returns {Function} - throttle処理された関数
 */
const throttle = (func, wait = 50) => {
    let timeout = null;
    return (...args) => {
        if (!timeout) {
            timeout = setTimeout(() => {
                func.apply(this, args);
                timeout = null;
            }, wait);
        }
    };
};

/**
 * スクロール位置に応じてボディクラスを更新する
 */
const updateScrollClasses = () => {
    const { scrollY, innerHeight } = window;
    const mv = document.querySelector(".Half__innerLeft")
    const footer = document.querySelector(".footer")

    // クラスの更新をまとめて処理
    const classes = {
        'outOfMv': mv ? (scrollY > mv.getBoundingClientRect().height) : false,
        'inFooter': footer ? (footer.getBoundingClientRect().bottom - 50 < innerHeight) : false,
    };

    // クラスの一括更新
    Object.entries(classes).forEach(([className, condition]) => {
        document.body.classList[condition ? 'add' : 'remove'](className);
    });
};

// throttleを適用したスクロールハンドラを設定
window.addEventListener('scroll', throttle(updateScrollClasses, 100));

// 初期実行
updateScrollClasses();